exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* https://www.freecodecamp.org/news/how-to-keep-your-footer-where-it-belongs-59c6aa05c59c/ */\n\n._2sVAbgcg1ljex9Y7hA29lX {\n  height: 5rem;\n}\n\n._3Ey-QFa_xCcg43tc1Gt8v- {\n  position: relative;\n  min-height: 100vh;\n}\n\n._3Ey-QFa_xCcg43tc1Gt8v-::after {\n  /* keep the height same of footerHeight and footerContainer::after same */\n  content: '';\n  display: inline-block;\n  height: 5rem;\n}\n", ""]);

// Exports
exports.locals = {
	"footerHeight": "_2sVAbgcg1ljex9Y7hA29lX",
	"footerContainer": "_3Ey-QFa_xCcg43tc1Gt8v-"
};